import React, { useState } from "react";
import SettingsModal from "components/Modal/SettingsModal";
import Widget from "components/Widget/Widget";
import { useSelector, useDispatch } from "react-redux";
import FirstStep from "./FirstStep";
import SecondStep from "./SecondStep";
import ThirdStep from "./ThirdStep";
import FourthStep from "./FourthStep";
import {
   saveTemplate,
   sendNewsletterWithSubs,
   sendNewsletterToEmailsFromList,
   sendNewsletterWithCSV,
   sendNewsletterToEmailsFromCSV
} from "services/restAPI/RestApi";
import NewsletterSettings from "../../Widgets/WidgetsSettings/Newsletter/NewsletterSettingsModal";
import "./steps.less";
import IntlMessages from "@util/IntlMessages";
import {
   checkIfTemplateExist,
   deleteTemplate,
   getMailTemplates,
   updateTemplate
} from "../../../services/restAPI/RestApi";
import { setNewsletterContent, setTemplateId } from "../../../appRedux/actions/Newsletter";
import { isCarlsbergUser } from "../../../util/Scripts";
import { Message, Button, Tag, Steps } from "../../BP2Components";

const { Step } = Steps;

const SwitchStep = (props) => {
   const dispatch = useDispatch();
   const [currentStep, setCurrentStep] = useState(0);
   const [disableSendButton, setDisableSendButton] = useState(false);
   const [saveTemplateLoading, setSaveTemplateLoading] = useState(false);
   const {
      newsletterContent,
      templateSaveable,
      templateIsNew,
      templateSubscribers,
      isFileAdded,
      csv
   } = useSelector(({ newsletter }) => newsletter);
   const authUser = useSelector(({ auth }) => auth.authUser);

   const next = () => {
      if (currentStep === 1 && templateSaveable) {
         setSaveTemplateLoading(true);
         if (templateIsNew) {
            checkIfTemplateExist(newsletterContentObj.templateName)
               .then((res) => {
                  if (res.data === false) {
                     saveTemplate(
                        newsletterContentObj.content,
                        newsletterContentObj.templateName,
                        newsletterContentObj.subject,
                        newsletterContentObj.coverPhotoURL
                     )
                        .then(() => {
                           /* Because new templates don't have their own ids (they are generated on backend), before sending email we have to
                            fetch one created when saving template to DB */
                           getMailTemplates()
                              .then((res) => {
                                 let lastTemplateOfList = res.data[res.data.length - 1];
                                 if (
                                    lastTemplateOfList.name === newsletterContentObj.templateName
                                 ) {
                                    dispatch(setTemplateId(lastTemplateOfList.id));
                                    dispatch(
                                       setNewsletterContent({
                                          templateId: lastTemplateOfList.id
                                       })
                                    );
                                 }
                                 setSaveTemplateLoading(false);
                                 Message.success("Template has been saved");
                                 setCurrentStep((curr) => curr + 1);
                              })
                              .catch(() => {
                                 setSaveTemplateLoading(false);
                              });
                        })
                        .catch(() => {
                           setSaveTemplateLoading(false);
                           Message.error("Template could not be saved");
                        });
                  } else if (res.data === true) {
                     setSaveTemplateLoading(false);
                     Message.error("Template with given name already exists");
                  }
               })
               .catch(() => {
                  setSaveTemplateLoading(false);
               });
         } else {
            let parsedContent = newsletterContentObj.content;

            /* parsedContent = parsedContent.replaceAll(
               `class="ql-align-center"`,
               `style="text-align:center"`
            );
            parsedContent = parsedContent.replaceAll(
               `class="ql-align-justify"`,
               `style="text-align:left"`
            );
            parsedContent = parsedContent.replaceAll(
               `class="ql-align-right"`,
               `style="text-align:right"`
            ); */

            updateTemplate(
               newsletterContentObj.templateId,
               newsletterContentObj.templateName,
               newsletterContentObj.subject,
               parsedContent,
               newsletterContentObj.coverPhotoURL
            )
               .then(() => {
                  Message.success("Template has been updated");
                  setCurrentStep((curr) => curr + 1);
               })
               .catch(() => {
                  Message.error("Template could not be updated");
               });
         }
      } else {
         setCurrentStep((curr) => curr + 1);
      }
   };
   const prev = () => {
      /* When creating new template and back to step 2 from step 3-Choose customers,
      user couldn't change anything that was on step 2 without errors.
      To overcome this, saved template needs to be deleted and saved once again
      (there is no templateId before saving it, so it's the only way)  */

      if (currentStep === 2 && templateIsNew) {
         getMailTemplates()
            .then((res) => {
               let lastTemplateOfList = res.data[res.data.length - 1];

               if (lastTemplateOfList.name === newsletterContentObj.templateName) {
                  deleteTemplate(lastTemplateOfList.id);
                  setCurrentStep((curr) => curr - 1);
               }
            })
            .catch(() => Message.error("Please try again."));
      } else if (currentStep > 0) {
         setCurrentStep((curr) => curr - 1);
      }
   };

   const steps = [
      {
         id: 1,
         title: <IntlMessages id="w.newsletter.chooseTemplate" />,
         content: <FirstStep id={props.widgetId} next={next} />
      },
      {
         id: 2,
         title: <IntlMessages id="w.newsletter.templateEditor" />,
         content: <SecondStep id={props.widgetId} />
      },
      {
         id: 3,
         title: <IntlMessages id="w.newsletter.chooseCustomers" />,
         content: <ThirdStep id={props.widgetId} />
      },
      {
         id: 4,
         title: <IntlMessages id="w.newsletter.summary" />,
         content: <FourthStep id={props.widgetId} />
      }
   ];

   let newsletterContentObj;
   if (newsletterContent) {
      newsletterContent.forEach((el) => {
         if (el.wId === props.widgetId) {
            newsletterContentObj = el;
         }
      });
   }
   const isNextButtonDisabled = () => {
      let isDisabled;
      if (currentStep === 1) {
         if (
            !!newsletterContentObj.content &&
            !!newsletterContentObj.templateName &&
            !!newsletterContentObj.subject
         ) {
            isDisabled = false;
         } else {
            isDisabled = true;
         }
      } else if (currentStep === 2) {
         let emailsChecked = 0;
         templateSubscribers.forEach((sub) => sub.checked && emailsChecked++);
         if ((templateSubscribers.length !== 0 && emailsChecked > 0) || isFileAdded) {
            isDisabled = false;
         } else {
            isDisabled = true;
         }
      } else {
         isDisabled = false;
      }
      return isDisabled;
   };

   const sendNewsletter = () => {
      setDisableSendButton(true);
      let data = newsletterContentObj;
      if (csv === null) {
         const subscribersIdList = [];
         const emailList = [];
         if (data.subscribers) {
            data.subscribers.forEach((sub) => {
               if (sub.checked === true) {
                  subscribersIdList.push(sub.id);
                  emailList.push(sub.email);
               }
            });
            if (isCarlsbergUser(authUser)) {
               sendNewsletterWithSubs(data.newsletterId, data.templateId, subscribersIdList)
                  .then(() => {
                     Message.success("Emails have been sent.");
                     setCurrentStep(0);
                     setDisableSendButton(false);
                  })
                  .catch(() => {
                     setDisableSendButton(false);
                     Message.error("Email could not be sent. Error.");
                  });
            } else {
               sendNewsletterToEmailsFromList(authUser.email, data.templateId, emailList)
                  .then(() => {
                     Message.success("Emails have been sent.");
                     setCurrentStep(0);
                     setDisableSendButton(false);
                  })
                  .catch(() => {
                     setDisableSendButton(false);

                     Message.error("Email could not be sent. Error.");
                  });
            }
         } else {
            setDisableSendButton(false);
            Message.error("Subscribers list is empty!");
         }
      } else {
         if (isCarlsbergUser(authUser)) {
            data.csv.append("mailTemplateId", data.templateId);
            data.csv.append("newsletterId", data.newsletterId);
            sendNewsletterWithCSV(data.csv)
               .then(() => {
                  Message.success("Emails have been sent");
                  setCurrentStep(0);
                  setDisableSendButton(false);
               })
               .catch(() => {
                  Message.error("Email could not be sent. Error.");
                  setDisableSendButton(false);
               });
         } else {
            const formDataWithCsvButByEmail = new FormData();

            if (csv) {
               formDataWithCsvButByEmail.append("file", csv);
            }

            sendNewsletterToEmailsFromCSV(
               authUser.email,
               data.templateId,
               formDataWithCsvButByEmail
            )
               .then(() => {
                  Message.success("Emails have been sent");
                  setCurrentStep(0);
                  setDisableSendButton(false);
               })
               .catch(() => {
                  Message.error("Email could not be sent. Error.");
                  setDisableSendButton(false);
               });
         }
      }
   };

   return (
      <Widget
         className="newsletter-widget"
         title={
            <>
               <Tag>{props.widgetId}</Tag>
            </>
         }
         bgColor={props.backgroundColourHex}
         role={props.role}
         extra={
            (props.role === "OWNER" || props.role === "MODERATOR") && (
               <SettingsModal
                  widgetName={props.widgetName}
                  widgetId={props.widgetId}
                  icon="setting"
                  deleteIcon="true"
                  children={<NewsletterSettings value={props} />}
                  id={props.listId}
               />
            )
         }
      >
         <Steps current={currentStep}>
            {steps.map((item) => (
               <Step key={item.id} title={item.title} />
            ))}
         </Steps>
         <div className="steps-content">{steps[currentStep].content}</div>
         <div className="steps-action">
            <Button
               className="steps-prev-btn"
               style={{
                  visibility: currentStep === 0 ? "hidden" : "visible"
               }}
               onClick={() => prev()}
            >
               <IntlMessages id="w.newsletter.previous" />
            </Button>
            {currentStep < steps.length - 1 && (
               <Button
                  buttonType="primary"
                  id={"newsletter-next-button"}
                  onClick={() => next()}
                  disabled={isNextButtonDisabled()}
                  style={{ display: currentStep === 0 ? "none" : "unset" }}
               >
                  <IntlMessages id="w.newsletter.next" />
               </Button>
            )}
            {currentStep === steps.length - 1 && (
               <Button
                  buttonType="primary"
                  onClick={() => sendNewsletter()}
                  disabled={disableSendButton}
               >
                  <IntlMessages id="w.newsletter.send" />
               </Button>
            )}
         </div>
      </Widget>
   );
};

export default SwitchStep;
